import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function BonusesSection() {
  return <section className="w-full bg-white px-6 py-20 sm:py-24" aria-labelledby="bonos-titulo" data-id="element-1" data-mp="vsw8y0tmyjd2">
      <div className="mx-auto max-w-6xl" data-id="element-2" data-mp="qtt7eqcv6v9u">
        <div id="bonos-titulo" data-id="element-3" data-mp="qsrx4o3oact6">
          <SectionHeading eyebrow="5 Bonos Estratégicos" title="Siempre incluidos, siempre gratis" subtitle="Implementación, clases listas, terminología, checklists y casos reales." data-id="element-4" data-mp="qvw57wk9dsp4" />
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-5" data-mp="1ejx7wouraewm">
          {bonuses.map(({
          number,
          title,
          description
        }) => <li key={number} className="flex h-full flex-col rounded-2xl border border-cream-200 bg-cream-50 p-7 shadow-card" data-id="element-6" data-mp="19kszi0fnol7c">
              <div className="flex items-center justify-between gap-3" data-id="element-7" data-mp="1jj9wbe19zu1b">
                <span className="text-sm font-semibold uppercase tracking-wider text-forest-600" data-id="element-8" data-mp="3pqbt5boisx14">
                  Bono {number}
                </span>
                <span className="rounded-full bg-ember-500 px-3 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-9" data-mp="3tsff4u8tfk0n">
                  Gratis
                </span>
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold leading-snug text-forest-800" data-id="element-10" data-mp="7li70ul6lrww">{title}</h3>
              <p className="mt-3 text-base leading-relaxed text-forest-700/70" data-id="element-11" data-mp="cja9gijgcwfc">{description}</p>
            </li>)}

          <li className="flex h-full flex-col justify-center rounded-2xl bg-forest-700 p-7 text-cream-50" data-id="element-12" data-mp="gj0wqc9rsuf4">
            <GiftIcon className="h-7 w-7 text-ember-400" aria-hidden="true" data-id="element-13" data-mp="qb700i5h2y9m" />
            <p className="mt-5 font-display text-2xl font-semibold leading-snug" data-id="element-14" data-mp="qdb1yujt9n79">
              Valor total de bonos $70 USD
            </p>
            <p className="mt-2 text-base text-cream-100/75" data-id="element-15" data-mp="108uv596zq7sb">GRATIS con tu Kit.</p>
          </li>
        </ul>
      </div>
    </section>;
}